export default "__VITE_ASSET__BRijnXTm__"